import { Link } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import "./breadcrumbs.css";

export type BreadcrumbItem = { label: string; to?: string; onClick?: () => void; disabled?: boolean };

export function Breadcrumbs({ label, items, className = "" }: { label: string; items: BreadcrumbItem[]; className?: string }) {
  return <nav className={`app-breadcrumbs ${className}`} aria-label={label}><ol>{items.map((item, index) =>
    <li key={index}>
      {index > 0 && <ChevronLeftIcon className="directional" aria-hidden="true" />}
      {index === items.length - 1 ? <span className="app-breadcrumb-current" aria-current="page">{item.label}</span>
        : item.onClick ? <button type="button" disabled={item.disabled} onClick={item.onClick}>{item.label}</button>
        : item.to ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
    </li>,
  )}</ol></nav>;
}
